export default __webpack_public_path__ + "static/media/cp_geo_sd.e6347c04.svg";